export default function () {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}



// WEBPACK FOOTER //
// ./scripts/utils/detect-safari.js